import React from 'react';
import { useSelector } from 'react-redux';
import SectionGrid from '~/app/Components/Dashboard/OverviewV2/primitives/SectionGrid.jsx';

const StateReturnsSubmitted = () => {
  const stateFedReturnsState = useSelector(state => state.dashboardOverview.heroCards);
  const stateFedReturnsData = stateFedReturnsState?.data?.returnsSubmitted1040;

  const stateReturnCards = [
    {
      key: 1,
      count: stateFedReturnsData?.StReject || 0,
      title: 'State Reject',
      loading: stateFedReturnsState?.loading,
      error: Boolean(
        stateFedReturnsState?.error || (!stateFedReturnsState?.loading && !stateFedReturnsData),
      ),
    },
  ];

  return <SectionGrid title="State Returns Submitted" cards={stateReturnCards}></SectionGrid>;
};

export default StateReturnsSubmitted;
